import { createSwiper, withResize } from '../../components/swiper-init.js';

export function initSwiperCaseStudiesWithResize() {
  withResize(() => {
    // Featured stays enabled on desktop and starts on the second slide.
    createSwiper('is--featured', {
      initialSlide: 1,
      breakpoints: { 992: { slidesPerView: 'auto' } },
    });
    createSwiper('is--testimonials');
  });
}
